<template>
  <div class="page">
    <div class="page__header d-flex flex-column">
      <div class="page__header-title mb-3">
        Usage Summary
      </div>

      <div class="page__header-tools">
        <b-row>
          <b-col class="col-lg-4">
            <div class="d-flex flex-row align-items-center form-custom-group">
              <label class="filter-label" :for="'fromDate'">FROM</label>
              <div class="ml-2 w-100 px-4 px-md-1">
                <b-form-datepicker :date-format-options="dateFormatOption" :min="minFromDate" :max="maxFromDate"
                  class="filter-date-input-white notranslate" :id="'fromDate'" type="date" v-model="fromDate">
                </b-form-datepicker>
              </div>
            </div>
          </b-col>
          <b-col class="col-lg-4">
            <div class="d-flex flex-row align-items-center position-relative form-custom-group">
              <label class="filter-label" :for="'toDate'">TO</label>
              <div class="ml-2 w-100 px-4 px-md-1">
                <b-form-datepicker :date-format-options="dateFormatOption" :min="minToDate" :max="maxToDate"
                  class="filter-date-input-white notranslate" :id="'toDate'" type="date" v-model="toDate">
                </b-form-datepicker>
              </div>
            </div>
          </b-col>
          <b-col class="col-lg-4">
            <div class="d-flex flex-row align-items-center form-custom-group">
              <label class="filter-label" :for="'fromDate'">Tenant Name</label>
              <b-select v-model="tenant">
                <option v-for="option in allTenantsList" :key="option.id" :value="option.id">
                  {{ option.name }} - {{ option.id }}
                </option>
              </b-select>
            </div>
          </b-col>
          <b-col class="col-lg-12">
            <div class="d-flex flex-row justify-content-end">
              <div class="d-flex ">
                <button @click="searchInfo" class="btn btn-success btn-sm mt-4" type="button">
                  <i class="icon-search"></i>
                  Search
                </button>
              </div>

              <div v-if="usersData.length || activeUsersCount || totalUsersCount">
                <button @click="excelClicked" class="btn btn-success btn-sm mt-4" type="button">
                  <i class="icon-download3"></i>
                  Excel
                </button>
              </div>
            </div>
          </b-col>

        </b-row>
        <b-row>

          <b-col>
            <b-breadcrumb class="mt-3" v-if="totalUsersCount || activeUsersCount">
              <b-breadcrumb-item v-if="totalUsersCount">
                <div>
                  <span class="mr-2 d-inline">Total Users</span>
                  <span>{{ totalUsersCount }}</span>
                </div>
              </b-breadcrumb-item>
              <b-breadcrumb-item v-if="activeUsersCount">
                <div>
                  <span class="mr-2 d-inline">Active Users</span>
                  <span>{{ activeUsersCount }}</span>
                </div>
              </b-breadcrumb-item>
            </b-breadcrumb>
          </b-col>

        </b-row>
      </div>
    </div>
    <div class="page__body">
      <div>
        <b-tabs content-class="mt-3">
          <b-tab title="Usage Details" @click="tabsSel('total')">
          </b-tab>
        </b-tabs>
      </div>
      <div v-if="usersData.length && this.tabSelected === 'total'">
        <DataUsageTotal :fields="fields" :items="usersData" @pagination="pagination2" :currentPage="pageTotal"
          :perPage="perPageTotal" />
      </div>


    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import DataUsageTotal from "../components/DataUsageTotal.vue";

const { mapGetters: mapGettersData, mapActions: mapActionsData, mapState } = createNamespacedHelpers(
  "admin/defaultView"
);

export default {
  components: {
    DataUsageTotal
  },

  data: function () {
    return {
      dateFormatOption: { year: 'numeric', month: 'short', day: '2-digit' },
      minFromDate: undefined,
      maxFromDate: undefined,
      minToDate: undefined,
      maxToDate: undefined,
      fromDate: '',
      toDate: '',
      tenant: '',
      tabSelected: 'total',
      fields: [{ key: "email" }, { key: "name" }, { key: "exercise_count" }, { key: "min" }, { key: "max" }, { key: "avg" }, { key: "sum" }],
      pageTotal: 1,
      perPageTotal: 10
    };
  },

  computed: {
    ...mapGettersData(["allTenantsList"]),
    ...mapState(["usersData", "activeUsersCount", "totalUsersCount"]),
  },
  mounted() {
    this.loadAllTenants();
  },

  beforeDestroy() {
    this.$router.go()
  },

  methods: {
    ...mapActionsData(["loadAllTenants", "loadUsageSummary"]),

    tabsSel(data) {
      this.tabSelected = data;
      let obj = {
        toDate: this.toDate,
        fromDate: this.fromDate,
        tenant: this.tenant,
        tabSelected: this.tabSelected
      }
      if (this.tabSelected === 'total') {
        obj.page = this.pageTotal;
        obj.perPage = this.perPageTotal;
      }
      this.loadUsageSummary(obj);

    },

    pagination2(data) {
      this.pageTotal = data.page;
      this.perPageTotal = data.perPage;
      const obj = {
        toDate: this.toDate,
        fromDate: this.fromDate,
        tenant: this.tenant,
        tabSelected: this.tabSelected,
        page: data.page,
        perPage: data.perPage
      }
      this.loadUsageSummary(obj);
    },

    searchInfo() {
      let obj = {
        toDate: this.toDate,
        fromDate: this.fromDate,
        tenant: this.tenant,
        tabSelected: this.tabSelected
      }
      if (this.tabSelected === 'total') {
        obj.page = this.pageTotal;
        obj.perPage = this.perPageTotal;
      }
      this.loadUsageSummary(obj);
    },
    excelClicked() {
      const filterTenantName = this.allTenantsList.filter(objData => objData.id === this.tenant);
      console.log("filterTenantName---", filterTenantName);
      const obj = {
        toDate: this.toDate,
        fromDate: this.fromDate,
        tenant: this.tenant,
        tabSelected: this.tabSelected,
        excelClicked: true,
        tenantName: filterTenantName[0].name
      }
      this.loadUsageSummary(obj);
    }
  },
};
</script>

<style>
.form-custom-group {
  display: flex;
  align-items: center;
  justify-content: center;
}

.form-custom-group .filter-label {
  font-size: 16px;
  line-height: 20px !important;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;

}

.form-custom-group .custom-select,
.form-custom-group .filter-date-input-white .form-control {
  height: 40px;
  font-size: 16px !important;
  line-break: 24px !important;
}

.btn.btn-success {
  font-size: 14px;
  padding: 10px 20px;
  font-weight: 700;
  background-color: #73BC44;
  border-radius: 100px;
  margin: 0 0 0 10px;
  border: 0 !important;
}
</style>